(() => {
  const animations = new WeakMap();
  document.addEventListener('click', event => {
    const summary=event.target.closest('.sidebar-care > summary');if(!summary)return;
    event.preventDefault();
    const details=summary.parentElement,content=details.querySelector('nav');
    const expand=details.dataset.targetOpen ? details.dataset.targetOpen!=='true' : !details.open;
    const start=details.open?content.getBoundingClientRect().height:0;
    const previous=animations.get(details);if(previous)previous.cancel();
    details.dataset.targetOpen=String(expand);
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){details.open=expand;delete details.dataset.targetOpen;return;}
    details.open=true;content.style.overflow='hidden';
    const animation=content.animate([{height:start+'px',opacity:start?1:0},{height:(expand?content.scrollHeight:0)+'px',opacity:expand?1:0}],{duration:240,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'});
    animations.set(details,animation);
    animation.finished.then(()=>{if(animations.get(details)!==animation)return;details.open=expand;delete details.dataset.targetOpen;animations.delete(details);animation.cancel();content.style.removeProperty('overflow');}).catch(()=>{});
  });
})();
